// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rP4p","newExpiryDate":"styles_newExpiryDate__2IAnA","footer":"styles_footer__2GA4j"};